import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Checkbox, FormControlLabel } from '@mui/material'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import LineInputV3 from '../../../common/lineInputV3'
import { ReportHeading } from '../common/ReportHeading'
import LuggageModificationReportTable from './LuggageModificationReportTable'
import moment from 'moment'
import { connect } from 'react-redux'
import { GetLRDetailsForPopUpV2Data, getLuggageModificationReportData } from '../../../../store/reports/reports_action'
import LuggageModel from './LuggageModel'
import { appendToUrl, getInt, isEmpty, removeDuplicatesFromArray } from '../../../common/helper'
import { getFtlBkngBranchList, updateLoader } from '../../../../store/common/common_action'
import * as URL from '../oldReportsUrls'
import { urls } from '../../../common/constants'
import { GetRequest } from '../../../common/api'
import Alert from '../../../common/alert'
import { PDFHeaderColumns, PDFHeaderColumnsForBoth, PDFHeaderColumnsForBothTwo, PDFHeaderColumnsFormattedLRNO, PDFHeaderColumnsFormattedLRNOTwo, PDFHeaderColumnsTwo } from './constant'
const LuggageModificationReport = (props) => {
  const {
    data: { common, reports, branchAndUserMasterReducer },
    getFtlBkngBranchList,
    getLuggageModificationReportData,
    GetLRDetailsForPopUpV2Data,
    updateAlertError,
    updateModal,
    updateLoader,
  } = props
  const { loginData, showModal, modalType, companySettings } = common
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
  const { BranchDetailsList } = branchAndUserMasterReducer
  const { lagguageModificationReportData, lrDetailsPopupData } = reports
  const reportName = 'Luggage Modification'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [lrSearchCheck, setLrSearchCheck] = useState(false)
  const [showModel, setShowModel] = useState(false)
  const [tableData, setTableData] = useState([])
  const [branchList, setBranchList] = useState([])
  const [branchListData, setBranchListData] = useState([])
  const [selBranch, setSelBranch] = useState('')
  const [showTable, setShowTable] = useState(false)
  const [lRInput, setLRInput] = useState('')
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })
  const loginCountryId = companySettings[0]?.DefaultCurrencyID
  const headerDataCol =
    UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
      ? loginCountryId !== 2
        ? PDFHeaderColumns
        : PDFHeaderColumnsTwo
      : UseFormattedLRinReports === 2
        ? loginCountryId !== 2
          ? PDFHeaderColumnsFormattedLRNO
          : PDFHeaderColumnsFormattedLRNOTwo
        : loginCountryId !== 2
          ? PDFHeaderColumnsForBoth
          : PDFHeaderColumnsForBothTwo
  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To  Date', textAlign: 'left' },
    { field: 'selFromBranch', header: 'From Branch', textAlign: 'left' },
    { field: 'lrSearch', header: 'LR Search', textAlign: 'left' },
  ]
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    selFromBranch: selBranch?.BranchName,
    lrSearch: lRInput,
    dataType: 'entry',
  }
  useEffect(() => {
    if (!lrSearchCheck) {
      setLRInput('')
    }
  }, [lrSearchCheck])
  useEffect(() => {
    if (branchList?.length > 0 && loginData) {
      const branches = branchList.map((record) => ({
        BranchID: record.BranchID,
        BranchName: record.BranchName,
      }))
      setBranchListData(branches)
      const defaultBranch = branches.find((branch) => branch.BranchID === loginData.intBranchID)
      setSelBranch(defaultBranch || branches[0])
    }
  }, [branchList, loginData])

  // useEffect(() => {
  //   let data = []
  //   data = lagguageModificationReportData?.map((val) => ({ ...val }))
  //   let TotalItemsOld = 0
  //   let TotalItemsNew = 0
  //   let TotalFreightOld = 0
  //   let TotalFreightNew = 0
  //   let TotalDocumentChargesOld = 0
  //   let TotalDocumentChargesNew = 0
  //   let TotalServiceTaxAmountOld = 0
  //   let TotalServiceTaxAmountNew = 0
  //   let TotalInsuranceOld = 0
  //   let TotalInsuranceNew = 0
  //   let TotalDeliveryChargesOld = 0
  //   let TotalDeliveryChargesNew = 0
  //   let TotalCollectionChargesOld = 0
  //   let TotalCollectionChargesNew = 0
  //   let TotalCartageAmountOld = 0
  //   let TotalCartageAmountNew = 0
  //   let TotalNetAmountOld = 0
  //   let TotalNetAmountNew = 0
  //   let TotalCommissionOld = 0
  //   let TotalCommissionNew = 0
  //   let TotalDemurrageChgOld = 0
  //   let TotalDemurrageChgNew = 0
  //   let TotalHamaliChargesOld = 0
  //   let TotalHamaliChargesNew = 0
  //   data?.map((val) => {
  //     TotalItemsOld += Number(val.ItemsOld)
  //     TotalItemsNew += Number(val.ItemsNew)
  //     TotalFreightOld += Number(val.FreightOld)
  //     TotalFreightNew += Number(val.FreightNew)
  //     TotalDocumentChargesOld += Number(val.DocumentChargesOld)
  //     TotalDocumentChargesNew += Number(val.DocumentChargesNew)
  //     TotalServiceTaxAmountOld += Number(val.ServiceTaxAmountOld)
  //     TotalServiceTaxAmountNew += Number(val.ServiceTaxAmountNew)
  //     TotalInsuranceOld += Number(val.InsuranceOld)
  //     TotalInsuranceNew += Number(val.InsuranceNew)
  //     TotalDeliveryChargesOld += Number(val.DeliveryChargesOld)
  //     TotalDeliveryChargesNew += Number(val.DeliveryChargesNew)
  //     TotalCollectionChargesOld += Number(val.CollectionChargesOld)
  //     TotalCollectionChargesNew += Number(val.CollectionChargesNew)
  //     TotalCartageAmountOld += Number(val.CartageAmountOld)
  //     TotalCartageAmountNew += Number(val.CartageAmountNew)
  //     TotalNetAmountOld += Number(val.NetAmountOld)
  //     TotalNetAmountNew += Number(val.NetAmountNew)
  //     TotalCommissionOld += Number(val.CommissionOld)
  //     TotalCommissionNew += Number(val.CommissionNew)
  //     TotalDemurrageChgOld += Number(val.DemurrageChgOld)
  //     TotalDemurrageChgNew += Number(val.DemurrageChgNew)
  //     TotalHamaliChargesOld += Number(val.HamaliChargesOld)
  //     TotalHamaliChargesNew += Number(val.HamaliChargesNew)
  //   })
  //   data?.push({
  //     LRNO: `Total`,
  //     ItemsOld: TotalItemsOld,
  //     ItemsNew: TotalItemsNew,
  //     FreightOld: TotalFreightOld,
  //     FreightNew: TotalFreightNew,
  //     DocumentChargesOld: TotalDocumentChargesOld,
  //     DocumentChargesNew: TotalDocumentChargesNew,
  //     ServiceTaxAmountOld: TotalServiceTaxAmountOld,
  //     ServiceTaxAmountNew: TotalServiceTaxAmountNew,
  //     InsuranceOld: TotalInsuranceOld,
  //     InsuranceNew: TotalInsuranceNew,
  //     DeliveryChargesOld: TotalDeliveryChargesOld,
  //     DeliveryChargesNew: TotalDeliveryChargesNew,
  //     CollectionChargesOld: TotalCollectionChargesOld,
  //     CollectionChargesNew: TotalCollectionChargesNew,
  //     CartageAmountOld: TotalCartageAmountOld,
  //     CartageAmountNew: TotalCartageAmountNew,
  //     NetAmountOld: TotalNetAmountOld,
  //     NetAmountNew: TotalNetAmountNew,
  //     CommissionOld: TotalCommissionOld,
  //     CommissionNew: TotalCartageAmountNew,
  //     DemurrageChgOld: TotalDemurrageChgOld,
  //     DemurrageChgNew: TotalDemurrageChgNew,
  //     HamaliChargesOld: TotalHamaliChargesOld,
  //     HamaliChargesNew: TotalHamaliChargesNew,
  //     dataType: 'total',
  //     IsRefund: 0,
  //   })
  //   setTableData(data || [])
  // }, [lagguageModificationReportData])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let BranchBody = {
        intUserID: loginData.intUserID,
        intCompanyID: loginData.intCompanyID,
        intCityID: 0,
        intBookingBranchID: -1,
      }
      getFtlBkngBranchList(BranchBody)
        .then((res) => {
          if (res.status === 'Success') {
            setBranchList(res?.Data?.Table)
          } else {
            setBranchList([])
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    }
  }, [loginData])
  const addTotalRow = (data = []) => {
    const totals = data.reduce(
      (acc, val) => {
        acc.ItemsOld += Number(val.ItemsOld || 0)
        acc.ItemsNew += Number(val.ItemsNew || 0)
        acc.FreightOld += Number(val.FreightOld || 0)
        acc.FreightNew += Number(val.FreightNew || 0)
        acc.DocumentChargesOld += Number(val.DocumentChargesOld || 0)
        acc.DocumentChargesNew += Number(val.DocumentChargesNew || 0)
        acc.ServiceTaxAmountOld += Number(val.ServiceTaxAmountOld || 0)
        acc.ServiceTaxAmountNew += Number(val.ServiceTaxAmountNew || 0)
        acc.InsuranceOld += Number(val.InsuranceOld || 0)
        acc.InsuranceNew += Number(val.InsuranceNew || 0)
        acc.DeliveryChargesOld += Number(val.DeliveryChargesOld || 0)
        acc.DeliveryChargesNew += Number(val.DeliveryChargesNew || 0)
        acc.CollectionChargesOld += Number(val.CollectionChargesOld || 0)
        acc.CollectionChargesNew += Number(val.CollectionChargesNew || 0)
        acc.CartageAmountOld += Number(val.CartageAmountOld || 0)
        acc.CartageAmountNew += Number(val.CartageAmountNew || 0)
        acc.NetAmountOld += Number(val.NetAmountOld || 0)
        acc.NetAmountNew += Number(val.NetAmountNew || 0)
        acc.CommissionOld += Number(val.CommissionOld || 0)
        acc.CommissionNew += Number(val.CommissionNew || 0)
        acc.DemurrageChgOld += Number(val.DemurrageChgOld || 0)
        acc.DemurrageChgNew += Number(val.DemurrageChgNew || 0)
        acc.HamaliChargesOld += Number(val.HamaliChargesOld || 0)
        acc.HamaliChargesNew += Number(val.HamaliChargesNew || 0)

        return acc
      },
      {
        ItemsOld: 0,
        ItemsNew: 0,
        FreightOld: 0,
        FreightNew: 0,
        DocumentChargesOld: 0,
        DocumentChargesNew: 0,
        ServiceTaxAmountOld: 0,
        ServiceTaxAmountNew: 0,
        InsuranceOld: 0,
        InsuranceNew: 0,
        DeliveryChargesOld: 0,
        DeliveryChargesNew: 0,
        CollectionChargesOld: 0,
        CollectionChargesNew: 0,
        CartageAmountOld: 0,
        CartageAmountNew: 0,
        NetAmountOld: 0,
        NetAmountNew: 0,
        CommissionOld: 0,
        CommissionNew: 0,
        DemurrageChgOld: 0,
        DemurrageChgNew: 0,
        HamaliChargesOld: 0,
        HamaliChargesNew: 0,
      }
    )

    return [
      ...data,
      {
        LRNO: "Total",
        ...totals,
        dataType: "total",
        IsRefund: 0,
        colSpan: {
          LRNO: 42
        },
        align: {
          LRNO: 'right'
        }
      },
    ]
  }
  const handleClick1 = () => {
    setShowTable(true)
    if (!lrSearchCheck) {
      const obj = {
        CompanyID: loginData.intCompanyID,
        dtDateFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtDateTo: moment(toDate).format('YYYY-MM-DD'),
        FromBranchId: selBranch?.BranchID,
        LRNo: '',
        Mode: 0,
        BookingID: 0,
      }
      updateLoader(true)
      GetRequest(urls.getLuggageModificationReport, obj).then((res) => {
        if (res.status == 'Success') {
          //  setShowReport(true)
          updateLoader(false)
          const data = res?.Data?.table?.map((val, index) => ({ ...val, dataType: 'entry' }))
          if (data?.length === 0) {
            setShowAlert({ show: true, message: 'No Data Found!' })
            return
          }
          const finalData = addTotalRow(data)
          // setTableData(data)
          let mainHeader = headerDataCol?.map((val) => ({
            ...val,
            field: val.field,
            align: val.align,
            export: val.exportHead,
            weight: 80,
            width: getInt(val.minWidth),
          }))
          const reportPayload = {
            reportName,
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: finalData,
            mainHeader: mainHeader,
            isShowPdfPrint: false,
          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        }
        else {
          updateLoader(false)
          setShowAlert({ show: true, message: res?.ErrMessage })
        }
      }).catch((err) => {
        updateLoader(false)
        console.log('Error:', err)
      })
      //  getLuggageModificationReportData(obj)
    } else {
      const obj2 = {
        strLRNO: lRInput,
        intCompanyID: loginData.intCompanyID,
        intBranchID: loginData.intBranchID,
        intUserID: loginData.intUserID,
        intBranchCityID: loginData.intBranchCityID,
      }
      GetLRDetailsForPopUpV2Data(obj2)
      setShowModel(true)
    }
  }
  const handleClose = () => {
    setShowModel(false)
  }
  const handleClick2 = () => {
    let url = URL.lugguageModificationReport
    let urlData = URL.lugguageModificationReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.dtDateFrom = fromDate.format('DD-MMM-YYYY')
    urlData.dtDateTo = toDate.format('DD-MMM-YYYY')
    urlData.FromBranchId = selBranch?.BranchID
    urlData.FromBranch = selBranch?.BranchName
    urlData.LRNo = 0
    urlData.BookingID = 0
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsxGrow} style={{ width: '5%' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Date'}
              id={'fromDate'}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                // focusElemnt(id.toDate)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '5%' }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Date'}
              value={toDate}
              id={'toDate'}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                // focusElemnt("goodGoBtn")
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'fromBranch'}
              label={'From Branch'}
              searchPlaceholder={`Search Selected From Branch`}
              defaultvalue={selBranch?.BranchName || ''}
              data={removeDuplicatesFromArray(branchListData, 'BranchID') || []}
              listWidth="230px"
              dataKey={`BranchName`}
              idKey={`BranchID`}
              disabled={lrSearchCheck}
              // onSelect={(obj) => { setSelSelectedCity(obj); setShowTable(false) }}
              onSelect={(obj) => {
                setSelBranch(obj)
                setShowTable(false)
              }}
              // nextId={id.gbSourceBranch}
              prevId={'goodGoBtn'}
              width="350px"
            />
          </Item>
          <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '40px' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id="LRSearch"
                  checked={lrSearchCheck}
                  onChange={() => {
                    setLrSearchCheck(!lrSearchCheck)
                  }}
                />
              }
              label={'LR Search?'}
              labelPlacement="end"
            />
          </Box>
          <Item className="input--wrapper" sx={sx.itemsx}>
            <LineInputV3
              // onKeyDown={(e) => {
              //     navigation1(e, 'memoDeliveryReceiverPhone', 'memoTablerowCheck0')
              // }}
              id="memoDeliveryReceiver"
              label="LR No."
              value={lRInput}
              onBlur={(e) => setLRInput(e.target.value)}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ cursor: 'pointer' }}>
            {/* <Item sx={sx.itemsx} style={{ cursor: "pointer" }} onKeyDown={(e)=>navigation3(e,showTable?disableExcel?"ExportToPdf":"ExportToExl":id.fromDate,id.anReportOptions,()=>handleClick1())}> */}
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              // id1={id.reportmainButton}
              // prevID={id.summaryCheck}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
        </Box>
        {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
      </Item>
      {/* {showTable ? (
        <LuggageModificationReportTable
          fromDate={fromDate}
          toDate={toDate}
          tableData={tableData}
          selBranch={selBranch}
          lRInput={lRInput}
          UseFormattedLRinReports={UseFormattedLRinReports}
        />
      ) : null} */}
      {showModel && lrSearchCheck ? (
        <LuggageModel
          updateModal={handleClose}
          lrDetailsPopupData={lrDetailsPopupData}
          setTableData={setTableData}
          setShowModel={setShowModel}
          fromDate={fromDate}
          toDate={toDate}
          selBranch={selBranch}
          lRInput={lRInput}
        />
      ) : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getLuggageModificationReportData, GetLRDetailsForPopUpV2Data, getFtlBkngBranchList, updateLoader }
export default connect(mapStateToProps, mapDispatchToProps)(LuggageModificationReport)
